import { combineReducers } from 'redux';
import powerMeterReducer from './powerMeterReducer';

export default combineReducers({
  powerMeter: powerMeterReducer,
});